import Bowser2 from 'bowser';
import View from 'root/view/base';

export default View.extend({
    render: function() {
        var chrome_link  = 'https://chrome.google.com/webstore/detail/userback/mpodoaaiifocfbchaphabldebijoilgp';
        var firefox_link = 'https://addons.mozilla.org/en-US/firefox/addon/userback/';
        var edge_link    = 'https://microsoftedge.microsoft.com/addons/detail/userback/giehcmiicobbgcijnnimmdnbgjijplga';

        var bowser = Bowser2.getParser(navigator.userAgent);
        var browser_name = bowser.getBrowserName().toLowerCase();

        var content =
        '<div class="browser-extension-icons">' +
            '<a href="' + chrome_link + '" target="chrome" rel="noopener">' +
                '<img src="/image/chrome_logo.png">' +
                '<div>' +
                    '<div>Add to Chrome</div>' +
                    (browser_name === 'chrome' ? '<div class="your-browser">Your browser</div>' : '') +
                '</div>' +
            '</a>' +
            '<a href="' + firefox_link + '" target="firefox" rel="noopener">' +
                '<img src="/image/firefox_logo.png">' +
                '<div>' +
                    '<div>Add to Firefox</div>' +
                    (browser_name === 'firefox' ? '<div class="your-browser">Your browser</div>' : '') +
                '</div>' +
            '</a>' +
            '<a href="' + edge_link + '" target="microsoft edge" rel="noopener">' +
                '<img src="/image/edge_logo.png">' +
                '<div>' +
                    '<div>Add to Edge</div>' +
                    (browser_name === 'microsoft edge' ? '<div class="your-browser">Your browser</div>' : '') +
                '</div>' +
            '</a>' +
        '</div>';

        this.$el.html(content);

        this.$el.find('a[target="' + browser_name + '"]').addClass('current');

        return this;
    }
});
